import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchObligation_alerts_alertIdDismiss = z.any()
export type TagsPatchObligation_alerts_alertIdDismiss = z.infer<typeof tagsPatchObligation_alerts_alertIdDismiss>

export const paramsPatchObligation_alerts_alertIdDismiss = z.object({ "alertId": z.string().uuid() })
export type ParamsPatchObligation_alerts_alertIdDismiss = z.infer<typeof paramsPatchObligation_alerts_alertIdDismiss>

export const bodyPatchObligation_alerts_alertIdDismiss = z.object({ "episodeId": z.string().uuid() })
export type BodyPatchObligation_alerts_alertIdDismiss = z.infer<typeof bodyPatchObligation_alerts_alertIdDismiss>

export const responsePatchObligation_alerts_alertIdDismiss = z.any()
export type ResponsePatchObligation_alerts_alertIdDismiss = z.infer<typeof responsePatchObligation_alerts_alertIdDismiss>

interface IPatchObligation_alerts_alertIdDismiss extends BaseMethodType {
  tags: TagsPatchObligation_alerts_alertIdDismiss,
  params: ParamsPatchObligation_alerts_alertIdDismiss,
  body: BodyPatchObligation_alerts_alertIdDismiss,
  response: ResponsePatchObligation_alerts_alertIdDismiss
}
export const URL = '/obligation-alerts/:alertId/dismiss'
export const validation = {
  patch: {
    tags: tagsPatchObligation_alerts_alertIdDismiss,
    params: paramsPatchObligation_alerts_alertIdDismiss,
    body: bodyPatchObligation_alerts_alertIdDismiss,
    response: responsePatchObligation_alerts_alertIdDismiss
  }
}
export interface Obligation_alerts_alertIdDismiss extends BaseRouteType {
  patch: IPatchObligation_alerts_alertIdDismiss
}